import SelectDropdown from 'src/components/select-dropdown/SelectDropdown';
import CrossIcon from 'src/icons/cross';

const FilterDropdown = ({
    className = '',
    contentClassName = '',
    placeholder,
    text,
    showPlaceholder,
    onResetClick,
    children,
}) => (
    <SelectDropdown
        label=""
        text={text}
        placeholder={placeholder}
        showPlaceholder={showPlaceholder}
        className={'w-48 ' + className}
        dropdownContainerClassName={`rounded-full ${!showPlaceholder && 'bg-[#008EC81A]'}`}
        color={!showPlaceholder ? 'text-blue-dark' : null}
        icon={!showPlaceholder ? <CrossIcon color="#008EC8" onClick={onResetClick} /> : null}
        contentClassName={contentClassName + ' drop-shadow-md'}
    >
        {(open, setOpen) => children(open, setOpen)}
    </SelectDropdown>
);

export default FilterDropdown;
